import { HttpClient } from '@angular/common/http';
import { Component, NgZone, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import { finalize, map, tap } from 'rxjs/operators';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';


@Component({
  selector: 'app-order-admin',
  templateUrl: './order-admin.component.html',
  styleUrls: ['./order-admin.component.sass']
})
export class OrderAdminComponent implements OnInit {
  productsOrdered: any;
  productsOrder: any;
  orders: any;
  email: string;
  password3: string;
  confirmPassword: string;
  productsOrderedListSubs: Subscription;
  productsOrderedList: ProductOrdered[];
  schoolsListSubs: Subscription;
  schools: any;
  stagesListSubs: Subscription;
  stages: any;
  gradesListSubs: Subscription;
  grades: any;
  // linesListSubs: Subscription;
  // lines: any;
  params: ProductOrdered[];
  isList: boolean = true;
  isNew: boolean = true;
  private routeSub: Subscription;
  type_accept: string;
  productOrderedForm: FormGroup;
  filterForm: FormGroup;
  pageEvent: PageEvent;
  modification_date: string;
  creation_date: string;
  school_name: string;
  stage_name: string;
  grade_name: string;
  student_name: string;
  readOnly: boolean = false;
  pageSize: number = 10;
  pageIndex: number = 0
  totalItems: any;
  selectedFiles: File;
  selectedSecondaryFiles: File;
  product_ordered_photo: any;
  displayedColumns: string[] = ['name', 'reference', 'school', 'stage', 'grade', 'num_list', 'product_es', 'product_en', 'product_cat', 'quantity', 'actions'];
  displayedColumns2: string[] = ['name', 'num_list', 'product_name_es', 'product_name_en', 'product_name_cat', 'quantity', 'value', 'actions'];

  dataSource: ProductOrdered = null;
  reference: string;
  value: string;
  status: string;
  next_unprocessed: string;
  disable_next_unprocessed: string;
  dataSource2 = new MatTableDataSource<any>();
  disableClearFilterButton: boolean = true;

  selectedPrinter = 'print-1'

  yearperiods: any = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;

  showOrderAdminProgressBar: boolean = true;
  showOrderAdminProgressBar2: boolean = true;

  constructor(
    public dataService: DataService,
    private http: HttpClient,
    public firebase: AngularFireAuth,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    public firebaseStorageService: FirebaseStorageService,
    private snackbar: MatSnackBar
  ) { }

  public getProductsOrdered() {
    this.productsOrderedListSubs = this.dataService
      .getProductsOrdered('')
      .subscribe(res => {
        this.productsOrdered = res;
      },
        console.error
      );
  }

  public getSchools(init: boolean = false) {

    // Retrieve order school filter from local storage.
    let schoolFilter = localStorage.getItem("order_school_filter");

    var params = {};
    params['page'] = 1
    params['size'] = 100000
    params['search'] = ''
    this.schoolsListSubs = this.dataService
      .getSchools(params)
      .subscribe(res => {
        this.schools = res['items'];
        this.schools = [{ 'id': null, 'name': "" }].concat(this.schools)

        if (schoolFilter && schoolFilter != "null") {
          let callTableUpdates = true;
          
          // We loop through schools to make sure our filter matches existing school.
          res['items'].forEach(school => {
            // We update only if our filter matches an existing school ID, otherwise no filter is applied.
            if (school.id == schoolFilter) {
              this.filterForm.controls["schools"].setValue(schoolFilter);
              callTableUpdates = false
              this.getStages(schoolFilter, false, init);
            }
          });

          //Actualizar aquí
          if (callTableUpdates) {
            var params = {};
            params['page'] = 1
            params['size'] = this.pageSize
            params['search'] = '';
            params['role'] = '';

            //this.fetchOrderedProducts(params);
            this.fetchTotalOrderedProducts(params);
          }
        }
      },
        console.error
      );
  }

  public getStages(schoolID: string, updateFilters: boolean = true, init: boolean = false) {

    if (updateFilters) {
      localStorage.setItem("order_school_filter", this.filterForm.controls["schools"].value);
      localStorage.setItem("order_stage_filter", "");
      localStorage.setItem("order_grade_filter", "");
    }

    let stageFilter = localStorage.getItem("order_stage_filter");

    this.stages = []
    this.grades = []

    this.productOrderedForm.controls["stages"].setValue('')
    this.productOrderedForm.controls["grades"].setValue('')
    // this.productOrderedForm.controls["lines"].setValue('')
    this.filterForm.controls["stages"].setValue('')
    this.filterForm.controls["grades"].setValue('')
    // this.filterForm.controls["lines"].setValue('')
    // this.applyFilter(null)

    this.stagesListSubs = this.dataService
      .getStages(schoolID)
      .subscribe(res => {
        this.stages = res;

        if (stageFilter) {

          let callTableUpdates = true

          this.stages.forEach(stage => {

            if (stageFilter == stage.id) {

              this.filterForm.controls["stages"].setValue(stageFilter);
              callTableUpdates = false
              this.getGrades(stageFilter, false, init);

            }

          });

          if (callTableUpdates) {
            this.applyFilter(null, null, init);
          }

        } else {

          this.stages = [{ 'id': null, 'name': "" }].concat(this.stages)
          this.applyFilter(null, null, init)

        }


        // this.productOrderedForm.controls["stages"].setValue(res[0]['id'])
        // this.getGrades(res[0]['id'])


      },
        console.error
      );
  }

  public getGrades(stageID: string, updateFilters: boolean = true, init: boolean = true) {

    if (updateFilters) {
      localStorage.setItem("order_school_filter", this.filterForm.controls["schools"].value);
      localStorage.setItem("order_stage_filter", this.filterForm.controls["stages"].value);
      localStorage.setItem("order_grade_filter", "");
    }

    let gradeFilter = localStorage.getItem("order_grade_filter");

    this.productOrderedForm.controls["grades"].setValue('')
    // this.productOrderedForm.controls["lines"].setValue('')
    this.filterForm.controls["grades"].setValue('')
    // this.filterForm.controls["lines"].setValue('')
    var params = {}
    params['school_id'] = ''
    params['stage_id'] = stageID
    this.gradesListSubs = this.dataService
      .getGrades(params)
      .subscribe(res => {
        this.grades = res;


        if (gradeFilter) {

          let callTableUpdates = true

          this.grades.forEach(grades => {
            if (gradeFilter == grades.id) {
              this.filterForm.controls["grades"].setValue(gradeFilter);
              callTableUpdates = false;
              this.applyFilter(null, gradeFilter, init);
            }
          });

          if (callTableUpdates) {
            this.applyFilter(null, null, init);
          }

        } else {
          this.applyFilter(null, null, init)
          this.grades = [{ 'id': null, 'name': "" }].concat(this.grades)
        }
      },
        console.error
      );
  }

  public clearFilterButtonState() {

    if (
      this.filterForm.controls["schools"].value != '' ||
      this.filterForm.controls["stages"].value != '' ||
      this.filterForm.controls["grades"].value != '' ||
      this.filterForm.controls["yearPeriod"].value != ''
    ) {
      this.disableClearFilterButton = false;
    } else {
      this.disableClearFilterButton = true;
    }

  }


  ngOnInit() {
    this.type_accept = '.jpeg, .png, .jpg';
    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')) {
        this.router.navigate(['/welcome']);
      }

    });
    this.productOrderedForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      schools: new FormControl('', Validators.required),
      stages: new FormControl('', Validators.required),
      grades: new FormControl('', Validators.required),
      num_list: new FormControl('', Validators.required),
    });


    let unprocessed_only_filter = true;

    if(localStorage.getItem('school_unprocessed_only_filter')){
      unprocessed_only_filter = localStorage.getItem('school_unprocessed_only_filter') == 'true' ? true : false
    }

    this.filterForm = this.formBuilder.group({
      schools: new FormControl(null),
      stages: new FormControl(null),
      grades: new FormControl(null),
      unprocessed_only: new FormControl(unprocessed_only_filter),
    });


    var params = {};
    params['page'] = 1
    params['size'] = 10//this.pageSize
    params['search'] = '';
    params['reference'] = '';
    params['unprocessed'] = this.filterForm.controls["unprocessed_only"].value;
    params['year_period'] = localStorage.getItem('order_year_period')

    if (!localStorage.getItem('order_school_filter') || localStorage.getItem('order_school_filter')=="null") {
      this.fetchOrderedProducts(params);
      this.fetchTotalOrderedProducts(params);
    } else {
      // this.applyFilter(localStorage.getItem('order_school_filter'))
    }

    this.getSchools(true)
    this.getYearPeriods()



    this.routeSub = this.route.params.subscribe(params => {
      if (params.reference) {
        this.isList = false;
        if (params.reference != 'new') {
          this.isNew = false;
          this.productsOrderedListSubs = this.dataService
            .getOrder(params)
            .subscribe(res => {
              this.orders = res;

              this.creation_date = this.orders.creation_date;
              this.modification_date = this.orders.modification_date;

              this.reference = this.orders.reference;
              this.value = this.orders.value;
              this.status = this.orders.status;
              this.product_ordered_photo = [{ "imageUrl": this.orders['product_photo'] }]
              this.dataService.getProductsOrder(params).subscribe(orders => {
                this.productsOrder = orders;
                this.school_name = orders[0].school_name
                this.stage_name = orders[0].stage_name
                this.grade_name = orders[0].grade_name
                this.student_name = orders[0].student_name
                this.dataSource2.data = this.productsOrder;
                this.showOrderAdminProgressBar2 = false;
                this.next_unprocessed = orders[0].next_unprocessed
                this.disable_next_unprocessed = orders[0].disable_next_unprocessed
              }),
                console.error

            });
        }
        else {
          this.isNew = true;


        }
      }
      else {
        this.isList = true;
        // this.getSchools()
      }

      //this.codeId = params['id'];
    });
  }

  private getYearPeriods() {
    this.filterForm.addControl('yearPeriod', new FormControl(''))
    this.dataService.getYearperiods({param: 'include-all'}).subscribe(yearperiods => {
      this.yearperiods = yearperiods;
      this.filterForm.disable();
      if(localStorage.getItem('order_year_period'))
      {
        this.filterForm.controls["yearPeriod"].setValue(localStorage.getItem('order_year_period'))
      }
    });
  }

  private fetchTotalOrderedProducts(params: {}) {

    this.dataService.getTotalProductsOrdered(params).pipe(
      map((totalItems) => this.totalItems = totalItems)
    ).subscribe(() => {
      this.showOrderAdminProgressBar = false; 
      this.filterForm.enable();
    });
  }

  private fetchOrderedProducts(params: {}) {

    if(localStorage.getItem('orders-admin'))
    {
      let data = JSON.parse(localStorage.getItem('orders-admin'))

      this.pageSize = data.pageSize
      this.pageIndex = data.page-1

      params['page'] = this.pageIndex+1

      params['size'] = this.pageSize
    }

    this.filterForm.disable();
    let sub = this.dataService.getProductsOrdered(params).pipe(
      map((tableData: ProductOrdered) => {
        this.dataSource = tableData
        let roughObjSize = JSON.stringify(tableData).length;
        console.log(roughObjSize)
      })
    ).subscribe(() => {
      this.showOrderAdminProgressBar = false; 
      this.filterForm.enable();
      sub.unsubscribe()
    });

  }

  selectFile(event, type) {
    if (type == 'primary') {
      this.selectedFiles = event.target.files;
    }
    else {
      this.selectedSecondaryFiles = event.target.files;
    }

  }


  goTo(productOrderedID: string) {
    let data = {}
    data['page'] = this.paginator.pageIndex+1
    data['pageSize'] = this.paginator.pageSize
    localStorage.setItem('orders-admin', JSON.stringify(data))
    this.router.navigateByUrl(`order-admin/${productOrderedID}`);
  }

  public setPrinter(printer) {
    console.log(printer)
    this.selectedPrinter = printer
  }

  public async printLabel(type: string): Promise<void> {
    let routeParams = this.route.snapshot.params
    
    let res = await this.dataService.printLabel(routeParams.reference, type, routeParams.id_student, this.selectedPrinter).toPromise()

    if (res != "ok") {
      let msg = await this.translate.get('alerts.print_error').toPromise()
      this.snackbar.openFromComponent(CustomPopupComponent, { data: msg, duration: 4000, panelClass: "error-snackbar" })
    }

    let msg = await this.translate.get('alerts.printing_label').toPromise()
    this.snackbar.openFromComponent(CustomPopupComponent, { data: msg, duration: 4000 })
  }




  applyFilter(event: Event, gradeID: any = false, init: boolean = false) {

    // Auto disables filter form when new filters are applied, gets enabled again when fetchOrderedProducts gets API response.
    this.filterForm.disable();

    if (event || gradeID) {
      localStorage.setItem("order_school_filter", this.filterForm.controls["schools"].value);
      localStorage.setItem("order_stage_filter", this.filterForm.controls["stages"].value);
      localStorage.setItem("order_grade_filter", this.filterForm.controls["grades"].value);
      localStorage.setItem("order_year_period", this.filterForm.controls["yearPeriod"].value);
    }

    this.showOrderAdminProgressBar = true
    // const filterValue = (event.target as HTMLInputElement).value;
    // this.dataSource.filter = filterValue.trim().toLowerCase();
    var params = {};
    params['page'] = 1
    params['size'] = this.pageSize
    params['school_id'] = this.filterForm.controls["schools"].value;
    params['stage_id'] = this.filterForm.controls["stages"].value;
    params['grade_id'] = this.filterForm.controls["grades"].value;
    params['unprocessed'] = this.filterForm.controls["unprocessed_only"].value;
    // params['line_id'] = this.filterForm.controls["lines"].value;
    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;

    params['year_period'] = this.filterForm.controls["yearPeriod"].value;

    localStorage.setItem('school_unprocessed_only_filter', (this.filterForm.controls["unprocessed_only"].value).toString())

    if(!init)
    {
      this.paginator.firstPage()
      this.pageIndex = 0
    }

    this.fetchOrderedProducts(params);

    this.fetchTotalOrderedProducts(params);

    this.clearFilterButtonState();
  }

  clearFilters() {

    localStorage.removeItem("order_school_filter");
    localStorage.removeItem("order_stage_filter");
    localStorage.removeItem("order_grade_filter");
    localStorage.removeItem("order_year_period");

    this.filterForm.controls["schools"].setValue('')
    this.filterForm.controls["stages"].setValue('')
    this.filterForm.controls["grades"].setValue('')
    this.filterForm.controls["yearPeriod"].setValue('')

    this.stages = []
    this.grades = []

    this.applyFilter(null)

  }



  onPaginateChange(event: PageEvent) {

    this.showOrderAdminProgressBar = true;

    this.pageSize = event.pageSize
    var params = {};

    params['page'] = event.pageIndex + 1
    params['size'] = this.pageSize
    params['role'] = ''
    params['school_id'] = this.filterForm.controls["schools"].value;
    params['stage_id'] = this.filterForm.controls["stages"].value;
    params['grade_id'] = this.filterForm.controls["grades"].value;
    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;
    params['unprocessed'] = this.filterForm.controls["unprocessed_only"].value;
    params['year_period'] = this.filterForm.controls["yearPeriod"].value;


    let sub = this.dataService.getProductsOrdered(params).pipe(
      map((tableData: ProductOrdered) => this.dataSource = tableData)
    ).subscribe(() => {
      this.showOrderAdminProgressBar = false
      sub.unsubscribe()
    })

    // let page = event.pageIndex;
    // let size = event.pageSize;

    // page = page + 1;

    // var params={};
    // params['catalogue'] = this.filterForm.controls["catalogue"].value;
    // params['theme'] = this.filterForm.controls["theme"].value;
    // params['page'] = page;
    // params['size'] = size;
    // this.dataService.getSchools(params).subscribe(schools => {
    //   this.schools = schools;
    //   this.dataSource.data = this.schools;

    //   // this.dataSource.filter = '';


    // });
  }
  processProduct(productOrderedID, status) {
    if ((status == 'reserved') || (status == 'reviewed') || (status == 'paid') || (status == 'lab')) {
      this.dataService.processProductOrdered(productOrderedID).subscribe(res => {
        if (res == 'ok') {
          if (this.isList == true) {
            this.applyFilter(null)
          }
          else {
            this.routeSub = this.route.params.subscribe(params => {
              this.dataService.getProductsOrder(params).subscribe(orders => {
                this.productsOrder = orders;
                this.school_name = orders[0].school_name
                this.stage_name = orders[0].stage_name
                this.grade_name = orders[0].grade_name
                this.student_name = orders[0].student_name
                this.dataSource2.data = this.productsOrder;
                this.status = orders[0].order_status
              }),
                console.error
            })
          }
        }
        else {
          this.translate.get('alerts.product_process_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    }
  }

  processAllProducts() {
    this.routeSub = this.route.params.subscribe(params => {

      this.dataService.processAllProductOrdered(params).subscribe(res => {
        if (res == 'ok') {
          this.dataService.getProductsOrder(params).subscribe(orders => {
            this.productsOrder = orders;
            this.school_name = orders[0].school_name
            this.stage_name = orders[0].stage_name
            this.grade_name = orders[0].grade_name
            this.student_name = orders[0].student_name
            this.dataSource2.data = this.productsOrder;
            this.status = orders[0].order_status
          }),
            console.error
        }
        else {
          this.translate.get('alerts.product_process_all_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    })
  }

  downloadInvoice(urlPhoto: string) {
    this.dataService.getFile(urlPhoto, 'application/pdf').subscribe(res => {
      let name = urlPhoto.split('/')

      var blob = new Blob([res], {type: 'application/pdf'});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("target", "_blank");
      link.download = name[1] + '.pdf';
      link.click();
    })

  }

}
export class ProductOrdered {
  constructor(
    public name: string,
    public last_name: string,
    public email: string,
    public id: string,
    public role: string
  ) { }
}
